import { render } from "./index.vue?vue&type=template&id=920acb0a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=920acb0a&lang=less&scoped=true"

import exportComponent from "C:\\webproject\\mofa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920acb0a"]])

export default __exports__